import { ServiceParameter } from '../service/service-parameter';

export class PropertyServiceParameter {
    serviceParameter: ServiceParameter;
    fieldValue: string;
    enabled: boolean | null;
}
